import React, { useEffect, useState, useRef } from "react";
import { AlertTriangle } from "lucide-react"; // ✅ Lucide icon
import "../style/InfoDisclaimer.css";

const InfoDisclaimer = ({ theme = "light" }) => {
  const [visible, setVisible] = useState(false);
  const iconRef = useRef(null);
  const popupRef = useRef(null);

  // Auto open after 2s and close after 2s more
  useEffect(() => {
    const openTimer = setTimeout(() => setVisible(true), 2000);
    const closeTimer = setTimeout(() => setVisible(false), 4000);
    return () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    };
  }, []);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="info-container">
      <button
        ref={iconRef}
        className={`warning-icon ${theme}`}
        onClick={() => setVisible((v) => !v)}
        aria-label="Metro timings disclaimer"
      >
        <AlertTriangle size={18} strokeWidth={2.2} />
      </button>

      <div
        ref={popupRef}
        className={`info-popup ${visible ? "visible" : ""}`}
      >
        Metro timings shown are approximate and may vary due to real-time operational updates.
      </div>
    </div>
  );
};

export default InfoDisclaimer;
